var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTime = function SvgIconTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 0a.5.5 0 0 1 .5.5V5h4a.5.5 0 1 1 0 1H0V.5A.5.5 0 0 1 .5 0Z",
    fill: "#1F1F1F"
  })));
};
export { SvgIconTime as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNTAwMTgzIDBDMC43NzYzMjUgMCAxLjAwMDE4IDAuMjIzODU4IDEuMDAwMTggMC41VjVINS4wMDAxOEM1LjI3NjMzIDUgNS41MDAxOCA1LjIyMzg2IDUuNTAwMTggNS41QzUuNTAwMTggNS43NzYxNCA1LjI3NjMzIDYgNS4wMDAxOCA2SDAuMDAwMTgzMTA1VjAuNUMwLjAwMDE4MzEwNSAwLjIyMzg1OCAwLjIyNDA0MSAwIDAuNTAwMTgzIDBaIiBmaWxsPSIjMUYxRjFGIi8+Cjwvc3ZnPgo=";